import React from 'react';
import PropTypes from 'prop-types';

import { ContextMenu, Dropdown } from '@weezevent/nacre';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import TicketOffice from '../../../models/ticket_office';

function SwitchTicketItem({ ticketsOffice, organization }) {
    const history = useHistory();
    return (
        <Dropdown.Item
            key={ticketsOffice.id}
            onClick={() => {
                history.push(`/ticket/O${organization.id}/ticket_offices/${ticketsOffice.id}/dashboard`);
            }}
        >
            {ticketsOffice.name}
        </Dropdown.Item>
    );
}

SwitchTicketItem.propTypes = {
    ticketsOffice: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired
};

export function SwitchTicketOffice({ organization, children }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [filteredTicketOffice, setFilteredTicketOffice] = React.useState([]);
    const [searched, setSearched] = React.useState(false);
    const [ticketsOffice, , sync] = TicketOffice.useApiModel({
        query: {
            deleted: '0'
        },
        organizationId: organization.id,
        onSuccess: ticketsOffice => {
            setFilteredTicketOffice(ticketsOffice);
        }
    });
    let switchMenuProps = React.useMemo(() => {
        return {
            text: t('ticket.switchTicket.cta'),
            headerText: searched && t('ticket.switchTicket.header_with_search'),
            footerText: t('ticket.switchTicket.footer_cta'),
            onFooterClick: () => {
                history.push(`/ticket/O${organization.id}/ticket_offices`);
            },
            searchProps: {
                placeholder: t('ticket.switchTicket.search_placeholder'),
                onChange: (synth, val) => {
                    if (!val) {
                        setSearched(false);
                        return sync();
                    }

                    setSearched(true);
                    sync({
                        query: {
                            search: val
                        }
                    });
                },
                handleReset: () => {
                    setSearched(false);
                    return sync();
                }
            },
            items: filteredTicketOffice.length ? (
                filteredTicketOffice.map(tickets_office => {
                    return <SwitchTicketItem key={tickets_office.id} ticketsOffice={tickets_office} organization={organization} />;
                })
            ) : (
                <div style={{ padding: '7px', fontSize: '12px' }}>{t('ticket.switchTicket.no_results')}</div>
            )
        };
    }, [organization, history, ticketsOffice, filteredTicketOffice]);

    // Throws error if more than 1 child
    React.Children.only(children);
    if (children.type !== ContextMenu) {
        throw new Error('SwitchTicket: must only have 1 child of type ContextMenu. Sorry.');
    }

    return React.cloneElement(children, {
        ...children.props,
        switchMenuProps
    });
}
